// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-R0t_","col":"styles_col__uqdba"};